enum LocalStorageData {
	auth = 'client/authData',
	profile = 'client/profile',
	booking = 'BOOKING',
	pwaAskForInstallation = 'pwaAskForInstallation',
	isPromoBannerShowed = 'isPromoBannerShowed',
	isPromoBannerShowedId = 'isPromoBannerShowedId',
	askForCookies = 'askForCookies',
	completedOrder = 'completed_order',
	userConfirmationDetails = 'userConfirmationDetails',
	orderGUID = 'ORDER_GUID',
	orderedTable = 'ordered_v2/table',
	orderedTakeaway = 'ordered_v2/takeaway',
	orderedDelivery = 'ordered_v2/delivery',
	favorites = 'favorites',
	customerInfo = 'customerInfo',
	order = 'ORDER',
	profileOrders = 'client/profileOrders',
	ordersFeedbacks = 'client/ordersFeedback',
}

export default LocalStorageData;
